/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import moment from 'moment';
import * as api from '@codegrade/api';
import { Just, Maybe, Nothing } from '@codegrade/maybe';
import * as utils from '@/utils';
import { isNetworkError } from '@/utils/error';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
const getToken = async (url) => {
    const { UserStore } = await import('./store');
    const res = UserStore.dangerousSession().chainNullable(({ accessToken }) => {
        if (utils.urlSameOrigin(url)) {
            return accessToken;
        }
        return null;
    });
    return res;
};
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class Client extends api.CodeGradeApi {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    maybeApp = Nothing;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(override) {
        super({
            base: '',
            shouldRetry: {
                tag: 'capped',
                maxAmountOfTries: 2,
                maxRetryAfter: moment.duration(30, 'seconds'),
            },
            token: async (_, request) => await getToken(request.url),
            processError: Maybe.of((request, err) => this.maybeApp.mapOrDefault(app => {
                if (err instanceof api.ApiResultError) {
                    app.handleHttpError(err.error, err.response.status, request.method, request.path, request.headers?.get('Authorization'));
                }
                else if (isNetworkError(err)) {
                    app.connectionError();
                }
                return err;
            }, err)),
            ...override,
        });
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    onVueCreated(app) {
        this.maybeApp = new Just(app);
    }
    /* eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation. */
    maybeRequest(maybe, callback) {
        return maybe.caseOf({
            Just: val => callback(val),
            Nothing: utils.emptyResponse,
        });
    }
}
const client = new Client();
/** An Unauthorized Codegrade Client for the frontend. */
export const unauthorizedClient = new Client({ token: Maybe.empty() });
export default client;
